export default "__VITE_ASSET__C13cOnqB__"